import log from 'salvo-lite/log'

class Collab {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._showButton = elem.querySelector('[data-show-button]')
        this._hideButton = elem.querySelector('[data-hide-button]')
        // this._number = elem.getAttribute('data-collab')
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        this._showButton.addEventListener('click', e => {
            let hiddenItems = this._elem.querySelectorAll('.visually-hidden')
            for (var i = 0; i < hiddenItems.length; i++) {
                if (hiddenItems[i]) {
                    hiddenItems[i].classList.remove('visually-hidden')
                    hiddenItems[i].classList.add('was-hidden')
                }
            }
            this._showButton.classList.add('visually-hidden')
            if (this._hideButton) {
                this._hideButton.classList.remove('visually-hidden')
            }
        })
        if (this._hideButton) {
            this._hideButton.addEventListener('click', e => {
                let wasHidden = this._elem.querySelectorAll('.was-hidden')
                for (var h = 0; h < wasHidden.length; h++) {
                    wasHidden[h].classList.add('visually-hidden')
                    wasHidden[h].classList.remove('was-hidden')
                }
                this._showButton.classList.remove('visually-hidden')
                this._hideButton.classList.add('visually-hidden')
            })
        }
    }
}

export default Collab



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Collab.js